export class FirebaseEmailSigninError extends Error {
  constructor(name: 'too-many-requests' | 'wrong-password') {
    super(name === 'too-many-requests' ? 'too-many-requests' : 'wrong-password')
    this.name = name
  }
}
